import { gql } from 'graphql-request';

export const PARTNER_SETTINGS = gql`
  query ($partnerKey: String!) {
    partnerSettings(partnerKey: $partnerKey) {
      __typename
      partner {
        partnerId
        partnerName
        partnerConfig {
          isPartnerActive
          showBackToPartner
          backToPartnerConfig {
            text
            link
          }
          blockerScreenConfig {
            banner
            title
            description
            primaryCta {
              text
              deepLink
              webLink
              viServiceWebLink
            }
          }
        }
      }
    }
  }
`;
